import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: Reports from audio → Audio types. Started from the lesson
 * page ("Start the walkthrough"); never auto-started. The officer adds any
 * recording of their own, then sets its type and speakers. It stops short of
 * the Upload button: it points at it instead of creating a case.
 */
const tour: TutorialDefinition = {
  id: "narrative-vs-interaction-audio",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Audio types",
  description: "Choose Narrative or Interaction for a recording and add its speakers.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "narrative-vs-interaction-audio",
  autoStart: false,
  steps: [
    {
      target: sel("newCaseDropdown"),
      title: "Start a new case",
      content: "Click New Case, then choose Upload Files.",
      disableBeacon: true,
      placement: "right",
      advanceOn: { selector: sel("newCaseUpload"), event: "click" },
      hint: "Click New Case, then Upload Files to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadDropzone"),
      waitFor: sel("uploadDropzone"),
      title: "Add a recording",
      content:
        "Drag in any recording, or click to browse. Use a conversation if you have one, such as an interview or body-cam audio.",
      disableBeacon: true,
      placement: "bottom",
      advanceOn: {
        selector: `${sel("uploadDropzone")} input[type="file"]`,
        event: "change",
      },
      hint: "Choose a file to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadTypeInteraction"),
      waitFor: sel("uploadTypeInteraction"),
      title: "Narrative or Interaction",
      content:
        "A Narrative is you alone, dictating the report. An Interaction is a conversation with more than one voice. Short files default to Narrative, so check the row. If your recording is a conversation, click Interaction.",
      disableBeacon: true,
      placement: "left",
      advanceOn: { selector: sel("uploadTypeInteraction"), event: "click" },
      hint: "Click Interaction to continue",
      spotlightClicks: true,
    },
    {
      target: sel("uploadAddSpeaker"),
      waitFor: sel("uploadAddSpeaker"),
      title: "Speaker Information",
      content:
        "Click Add Speaker for each person, then pick a role (Officer, Detective, Investigator, Victim, Suspect, Witness, Complainant, Other) and a name if you have one. Names you enter carry through to the draft. Spoken Languages is just below, for conversations that were not entirely in English.",
      disableBeacon: true,
      placement: "left",
    },
    {
      target: sel("uploadSubmit"),
      waitFor: sel("uploadSubmit"),
      title: "Upload",
      content:
        "When the row is set, click Upload to transcribe it. You can close this window now to leave without uploading.",
      disableBeacon: true,
      placement: "top",
    },
  ],
};

export default tour;
